export default Object.freeze({
  main:
  {
    _name: 'CSidebarNavTitle',
    _children: ['メインメニュー']
  },
  /* 
favorite:
  {
    _name: 'CSidebarNavDropdown',
    name: 'お気に入り',
    icon: 'cil-star',
    items: [
      {
        name: '経歴一覧',
        to: '/top-page/careers'
      },
      {
        name: 'ユーザー',
        to: '/top-page/master/users'
      }
    ]
  }, 
  */
  profile:
  {
    _name: 'CSidebarNavDropdown',
    name: 'プロフィール',
    icon: 'cil-user',
    items: [
      {
        name: 'アカウント情報',
        to: '/top-page/profile/accounts'
      },
      {
        name: '経歴情報',
        to: '/top-page/profile/careerEditing'
      },
    ]
  },
  careers:
  {
    _name: 'CSidebarNavItem',
    name: '経歴一覧',
    to: '/top-page/careers',
    icon: 'cil-spreadsheet'
  },
  qualification:
  {
    _name: 'CSidebarNavItem',
    name: '個人資格情報一覧',
    to: '/top-page/qualificationinfo',
    icon: 'cil-spreadsheet'
  },
  skillinfo:
  {
    _name: 'CSidebarNavItem',
    name: '個人スキル情報一覧',
    to: '/top-page/skillinfo',
    icon: 'cil-spreadsheet'
  },
  master:
  {
    _name: 'CSidebarNavDropdown',
    name: 'マスタメンテナンス',
    icon: 'cil-circle',
    items: []
  },
  user: {
    name: 'ユーザー',
    to: '/top-page/master/users'
  },
  positions: {
    name: '役職',
    to: '/top-page/master/positions'
  },
  organizations: {
    name: '組織',
    to: '/top-page/master/organizations'
  },
  skills: {
    name: 'スキル',
    to: '/top-page/master/skills'
  },
  qualifications:
  {
    name: '資格',
    to: '/top-page/master/qualifications'
  },
  authorities:
  {
    name: '閲覧権限',
    to: '/top-page/master/authorities'
  }
})